import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowUpRight,
  Mail,
  Phone,
  MapPin,
  Instagram,
  Linkedin,
} from "lucide-react";
import { BRAND, NAV_LINKS } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-10">
        {/* Big CTA */}
        <div className="border-b border-white/15 pb-20 mb-16">
          <p className="text-[11px] uppercase tracking-[0.32em] text-white/60 mb-6">
            Let's build something unmissable
          </p>
          <h2 className="font-display text-[14vw] md:text-[10vw] leading-[0.92] uppercase">
            Reach the <br />
            <span className="italic font-serif-display font-black">streets.</span>
          </h2>
          <Link
            to="/contact"
            className="mt-10 inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-7 py-4 border border-white hover:bg-white hover:text-black transition-colors duration-200"
          >
            Start a Campaign
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="font-serif-display text-3xl font-black mb-3">
              {BRAND.short}
            </div>
            <p className="text-white/70 max-w-md leading-relaxed text-sm">
              Adways Marketing Solution — a Pan-India Out-of-Home advertising
              partner building brands across streets, transit, malls, and
              skylines.
            </p>

            {/* Socials */}
            <div className="flex items-center gap-3 mt-8">
              <a
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="group inline-flex items-center gap-3 border border-white/20 hover:border-white px-4 py-3 transition-colors"
              >
                <Instagram className="w-4 h-4" />
                <span className="text-[12px] uppercase tracking-[0.22em] font-semibold">
                  {BRAND.instagram}
                </span>
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-12 h-12 border border-white/20 hover:border-white inline-flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.24em] text-white/50 mb-4">
              Explore
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/85 hover:text-white nav-link text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.24em] text-white/50 mb-4">
              Contact
            </p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-white/60 shrink-0" />
                <div className="text-white/85">
                  <div className="text-[10px] uppercase tracking-[0.24em] text-white/45 mb-1">
                    {BRAND.addressLabel}
                  </div>
                  <span>{BRAND.address}</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-white/60 shrink-0" />
                <a
                  className="text-white/85 hover:text-white break-all"
                  href={`mailto:${BRAND.email}`}
                >
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-white/60 shrink-0" />
                <div className="text-white/85 flex flex-col gap-1">
                  {BRAND.phones.map((p) => (
                    <a
                      key={p}
                      href={`tel:${p.replace(/\s+/g, "")}`}
                      className="hover:text-white"
                    >
                      {p}
                    </a>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom strip — credit + meta */}
        <div className="mt-16 pt-8 border-t border-white/15 flex flex-col gap-6 md:gap-4 md:flex-row md:items-center md:justify-between text-[11px] uppercase tracking-[0.2em] text-white/45">
          <span>
            © {new Date().getFullYear()} Adways Marketing Solutions. All rights
            reserved.
          </span>
          <span className="font-serif-display normal-case tracking-normal italic text-[13px] text-white/85">
            Created and visualised by{" "}
            <span className="not-italic font-display uppercase tracking-wider text-white">
              Anhadd Chopra
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
